import * as React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import styles from './NavTabItem.module.scss';

type NavTabItemProps = {
    title: string;
    href: string;
    isExact?: boolean;
    isNavActive?: boolean;
};

export const NavTabItem: React.FC<NavTabItemProps> = React.memo(({ title, href, isExact, isNavActive }) => {

    return (
        <NavLink
            end={isExact}
            to={href}
            className={({ isActive }) => classNames(styles.tabItem, (isActive || isNavActive) && styles.active)}
        >
            {title}
        </NavLink>
    );
});
